export default {
    state: {
        customers: {
            schedule: "all",
            estimator: "all",
            status: "all",
            assign: "all",
            keyword: "",
            phone: "",
            daterange: "",
            type: ""
        },
        schedule: {
            keyword: "",
            status: ["active", "completed"],
            daterange: "",
            cleaner: []
        },
    },
    getters: {

    },
    mutations: {
        SET_CUSTOMERS_FILTER : (state,payload) => {
            state.customers = payload
        },
        SET_SCHEDULE_FILTER : (state,payload) => {
            state.schedule = payload
        },
    },
    actions: {

    }
}